module.exports = __webpack_public_path__ + "assets/img/facergt-offlinenir.e37c4b72.png";